"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ClusterUpdateErrorModal = () => (react_1.default.createElement(react_core_1.Modal, { title: "Unable to update cluster", isOpen: true, variant: react_core_1.ModalVariant.small, showClose: false, titleIconVariant: "danger", actions: [
        react_1.default.createElement(react_core_1.Button, { key: "refresh", variant: react_core_1.ButtonVariant.primary, onClick: () => window.location.reload() }, "Refresh page"),
    ] }, "The service is down, undergoing maintenance, or experiencing another issue."));
exports.default = ClusterUpdateErrorModal;
//# sourceMappingURL=ClusterUpdateErrorModal.js.map